export const switchElements = (e, expectedClass, displayType = 'block') => {
	const element = e.target.classList.contains(expectedClass) ? e.target : e.target.parentNode;
	if (element && element.classList) {
		if (element.classList.contains(expectedClass) && element.getAttribute('data-show') !== undefined) {
			const display = element.getAttribute('data-display');

			element.style = 'display: none';
			document
				.querySelectorAll(element.getAttribute('data-show'))
				.forEach((el) => (el.style = 'display: ' + (display ? display : displayType)));

			const oppositeButtonSelector = element.getAttribute('data-opposite-button');
			if (oppositeButtonSelector) {
				document.querySelector(oppositeButtonSelector).style = 'display: ' + displayType;
			}
			return true;
		}
	}

	return false;
};
